import { useState, useEffect } from 'react'
import { designService } from '../services/api'
import LoadingSpinner from './LoadingSpinner'

export default function ImageBrowser({ onSelect, onBack }) {
  const [images, setImages] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    loadImages()
  }, [])

  const loadImages = async () => {
    try {
      setLoading(true)
      const response = await designService.listImages()
      console.log('Images response:', response)
      console.log('Images data:', response.data)

      // Handle both array response and wrapped response
      const imageList = Array.isArray(response.data)
        ? response.data
        : Array.isArray(response.data?.data)
        ? response.data.data
        : []

      console.log('Parsed images:', imageList)
      setImages(imageList)
    } catch (err) {
      console.error('Error loading images:', err)
      // Don't show technical error messages to users
      setImages([])
    } finally {
      setLoading(false)
    }
  }

  const filteredImages = images.filter(img =>
    img.filename.toLowerCase().includes(searchTerm.toLowerCase())
  )

  if (loading) return <LoadingSpinner />

  return (
    <div className="image-browser">
      <div className="browser-header">
        <h2>Select Product Image</h2>
        <button className="back-btn" onClick={onBack}>← Back</button>
      </div>

      <div className="search-box">
        <input
          type="text"
          placeholder="Search images..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {images.length === 0 ? (
        <div className="empty-state">
          <p style={{ fontSize: '3rem', marginBottom: '1rem' }}>🖼️</p>
          <h3>No Product Images Yet</h3>
          <p style={{ marginBottom: '1.5rem' }}>Upload your product photos to get started</p>
          <div style={{
            backgroundColor: '#f3f3f3',
            padding: '1.5rem',
            borderRadius: '8px',
            marginTop: '1rem',
            textAlign: 'left',
            fontSize: '0.95rem',
            lineHeight: '1.8'
          }}>
            <p style={{ marginBottom: '1rem', fontWeight: '600', color: '#d90d0e' }}>
              📝 How to add images:
            </p>
            <ol style={{ marginLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li>Contact your administrator to upload product images</li>
              <li>Once uploaded, they will appear here</li>
              <li>You can then select them for your designs</li>
            </ol>
          </div>
        </div>
      ) : filteredImages.length === 0 ? (
        <div className="empty-state">
          <p>😕 No matching images</p>
          <p style={{ fontSize: '0.9rem', marginTop: '0.5rem' }}>Try adjusting your search</p>
          <button
            onClick={() => setSearchTerm('')}
            style={{
              marginTop: '1rem',
              padding: '0.6rem 1.2rem',
              backgroundColor: '#d90d0e',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            Clear Search
          </button>
        </div>
      ) : (
        <div className="images-grid">
          {filteredImages.map((image, idx) => (
            <div
              key={idx}
              className="image-card"
              onClick={() => onSelect(image)}
            >
              <div className="image-container">
                <img src={image.url} alt={image.filename} />
              </div>
              <p className="image-name">{image.filename}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
